import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import {
  getFileSettings,
  getOutputFileSettings,
} from "../store/workspaceSlice";
import { useSelector } from "react-redux";

const ViewFileSettings = ({ isOpen, toggleAccordion }) => {
  const fileSettings = useSelector(getFileSettings);
  const outputFileSettings = useSelector(getOutputFileSettings);
  // showFileSettings is true if there is a header row or rows/columns to avoid an other file settings
  const showInputFileSettings =
    fileSettings.headerRow !== "" ||
    fileSettings.rowsToAvoid.length !== 0 ||
    fileSettings.columnsToAvoid.length !== 0 ||
    fileSettings.sortColumn?.toggleSortButton;
  const showOutputFileSettings = outputFileSettings?.rowsToSkip !== undefined;

  return (
    // only show this component if there is a header row or rows/columns to avoid and other file settings
    <div
      className={`bg-gray-50 rounded-md shadow
                ${
                  showInputFileSettings || showOutputFileSettings
                    ? "block"
                    : "hidden"
                }
                `}
    >
      {/* Chevron and Heading  */}
      <div
        className="flex justify-between items-center cursor-pointer p-2 rounded hover:bg-gray-300 border border-gray-400 shadow hover:outline-none text-gray-500"
        onClick={() => {
          (showInputFileSettings ||
            showOutputFileSettings ||
            isOpen.fileSettings) &&
            toggleAccordion("fileSettings");
        }}
      >
        <div></div>
        <h2 className="text-red-600 font-medium">File Settings</h2>
        {isOpen.fileSettings ? <FaChevronUp /> : <FaChevronDown />}
      </div>

      <div
        className={`bg-gray-50 rounded-md ${
          !isOpen.fileSettings && "hidden"
        }   overflow-y-auto transition-all duration-300 font-medium text-gray-700`}
      >
        {/* Input File settings only */}
        <div className={`m-2 ${showInputFileSettings ? "block" : "hidden"}`}>
          <h1 className=" flex justify-start items-end p-1 underline bg-gray-400/85 border-b-2 border-gray-600 text-sm">
            Input File settings
          </h1>

          {fileSettings.headerRow && (
            <div className="bg-gray-50 p-2  rounded-md shadow mb-2 max-h-60 overflow-y-auto flex justify-between my-1">
              <span>Header Row:</span>
              <span className="text-sm text-gray-500">
                {fileSettings.headerRow}
              </span>
            </div>
          )}

          {fileSettings.rowsToAvoid.length > 0 && (
            <div className="bg-gray-50 p-2 rounded-md shadow mb-2 max-h-60 overflow-y-auto flex justify-between my-1">
              <span>Rows to avoid:</span>
              <span className="text-sm text-gray-500">
                {fileSettings.rowsToAvoid.join(", ")}
              </span>
            </div>
          )}
          {fileSettings.columnsToAvoid.length > 0 && (
            <div className="bg-gray-50 p-2 rounded-md shadow mb-2 max-h-60 overflow-y-auto flex justify-between my-1">
              <span>Columns to avoid:</span>
              <span className="text-sm text-gray-500">
                {fileSettings.columnsToAvoid.join(", ")}
              </span>
            </div>
          )}
          {fileSettings.sortColumn.toggleSortButton && (
            <div className="bg-gray-50 p-2 rounded-md shadow mb-2 max-h-60 overflow-y-auto flex justify-between my-1">
              <span>Sort Column:</span>
              <span className="text-sm text-gray-500">
                {`${fileSettings.sortColumn.sortColumnName} , (${fileSettings.sortColumn.sortColumnType})`}
              </span>
            </div>
          )}
          {fileSettings.sortColumn.toggleSortButton && (
            <div className="bg-gray-50 p-2 rounded-md shadow mb-2 max-h-60 overflow-y-auto flex justify-between my-1">
              <span>Sort Order:</span>
              <span className="text-sm text-gray-500">
                {`${fileSettings.sortColumn.order === "asc" ? 'Ascending':'Descending'}` }
              </span>
            </div>
          )}
        </div>
        {/* Output File settings only */}
        <div className={`m-2 ${showOutputFileSettings ? "block" : "hidden"}`}>
          <h1 className=" flex justify-start items-end p-1 underline bg-gray-400/85 border-b-2 border-gray-600 text-sm">
            Output File settings
          </h1>
          {outputFileSettings?.rowsToSkip && (
            <div className="bg-gray-50 p-2  rounded-md shadow mb-2 max-h-60 overflow-y-auto flex justify-between my-1">
              <span>Rows to skip:</span>
              <span className="text-sm text-gray-500">
                {outputFileSettings.rowsToSkip}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default ViewFileSettings;
